import { createListCollection, Dialog, Icon, IconButton, Link, Stack } from "@chakra-ui/react";
import { XIcon } from "@phosphor-icons/react/dist/ssr";
import { useRouter } from "next/router";
import { useState } from "react";

import { useGetHubspotFormsFieldsQuery } from "@/hooks/microservicesApi";

import FormBrokers from "../brokers/FormBrokers";
import FormRegistro from "./FormRegistro";

const ModalRegistro = ({ guiaBroker = false, small = false }) => {
    const router = useRouter();
    const [isOpen, setIsOpen] = useState(false);

    const onOpen = () => setIsOpen(true);
    const onClose = () => setIsOpen(false);

    const { data: formFields } = useGetHubspotFormsFieldsQuery(
        "1149f55e-bdd0-43d9-844c-59f6e3273da1"
    );

    const filteredFields = formFields?.data
        ?.flatMap((group) => group.fields)
        ?.find((field) => field.name === "desarrollo_de_interes_soy_inmobiliaria_");

    const corretajeListCollectionItems =
        filteredFields?.options
            ?.filter((option) => option.label?.toLowerCase().includes("corretaje"))
            .map((option) => ({
                value: option.value,
                label: option.label,
            })) || [];

    const guiarentListCollectionItems =
        filteredFields?.options
            ?.filter((option) => option.label?.toLowerCase().includes("guiarent"))
            .map((option) => ({
                value: option.value,
                label: option.label,
            })) || [];

    const otherListCollectionItems =
        filteredFields?.options
            ?.filter((option) => {
                const label = option.label?.toLowerCase() || "";
                return !label.includes("corretaje") && !label.includes("guiarent");
            })
            .map((option) => ({
                value: option.value,
                label: option.label,
            })) || [];

    const corretajeFieldOptions = createListCollection({
        items: corretajeListCollectionItems,
    });

    const guiarentFieldOptions = createListCollection({
        items: guiarentListCollectionItems,
    });

    const otherFieldOptions = createListCollection({
        items: otherListCollectionItems,
    });

    return (
        <>
            {guiaBroker && router.route === "/guiabroker" ? (
                <Link
                    mb={4}
                    p={3}
                    px={16}
                    rounded="full"
                    bg="rgba(255, 205, 0, 1)"
                    color="black"
                    fontWeight={500}
                    fontSize={small ? "sm" : "lg"}
                    onClick={onOpen}
                >
                    Quiero ser Guía Broker
                </Link>
            ) : guiaBroker ? (
                <Link
                    mb={4}
                    px={10}
                    py={3}
                    rounded="full"
                    bg="rgba(255, 205, 0, 1)"
                    color="black"
                    fontWeight={500}
                    fontSize={small ? "sm" : "lg"}
                    onClick={onOpen}
                    justifyContent="center"
                >
                    Registro de cliente
                </Link>
            ) : (
                <Link mb={4} color="black" fontWeight={500} fontSize="md" onClick={onOpen}>
                    <u>Registro de cliente</u>
                </Link>
            )}
            <Dialog.Root
                open={isOpen}
                onOpenChange={() => onClose()}
                size="xl"
                preventScroll
                placement="center"
                scrollBehavior="inside"
            >
                <Dialog.Backdrop />
                <Dialog.Positioner>
                    <Dialog.Content borderRadius="2xl" pt={10}>
                        <Dialog.Header textAlign="center"></Dialog.Header>
                        <Dialog.CloseTrigger asChild>
                            <IconButton
                                position="absolute"
                                top="-15px"
                                right="-15px"
                                borderRadius="50%" // Hace el botón circular
                                backgroundColor="gray.300" // Color gris del botón
                                _hover={{ backgroundColor: "gray.400" }} // Cambia el color al pasar el cursor
                                width="50px" // Tamaño del botón
                                height="50px"
                                color="black"
                            >
                                <Icon>
                                    <XIcon weight="bold" />
                                </Icon>
                            </IconButton>
                        </Dialog.CloseTrigger>
                        <Dialog.Body pb={3}>
                            <Stack>
                                {router.route === "/guiabroker" ? (
                                    <FormBrokers />
                                ) : (
                                    <FormRegistro
                                        corretajeFieldOptions={corretajeFieldOptions}
                                        guiarentFieldOptions={guiarentFieldOptions}
                                        otherFieldOptions={otherFieldOptions}
                                    />
                                )}
                            </Stack>
                        </Dialog.Body>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Dialog.Root>
        </>
    );
};

export default ModalRegistro;
